import React from "react";
import { OnboardingVisitInstanceId } from "../messages";
import { Visit } from "../system/AppState/AppVisitsState";
import { HashSet } from "../utils/HashSet";
import { CheckedOnboardingVisitData } from "./OnboardingVisitActivity";
import WithMultiShift from "./WithMultiShift";

interface Props {
  visit: Visit.Onboarding;
  onClickRequest: () => void;
  onClickCancel: () => void;
  children: (props: {
    onClickRequest: () => void;
    onClickCancel: () => void;
    checkedVisits: HashSet<OnboardingVisitInstanceId>;
    checkedPatterns: HashSet<string>;
    areAllShiftsChecked: boolean;
    onCheckVisit: (visitData: CheckedOnboardingVisitData) => void;
  }) => React.ReactNode;
}

export default function WithOnboardingMultiShift(props: Props) {
  return WithMultiShift<"OnboardingVisit">(props);
}
